module.exports = __webpack_public_path__ + "static/media/lumin-bottles-with-one-sample-swatch.214fa2f7.jpg";